import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const TermsPage = () => {
  const { t } = useTranslation();

  const sections = [
    { title: t('terms.section1Title'), content: t('terms.section1Text') },
    { title: t('terms.section2Title'), content: t('terms.section2Text') },
    { title: t('terms.section3Title'), content: t('terms.section3Text') },
    { title: t('terms.section4Title'), content: t('terms.section4Text') },
    { title: t('terms.section5Title'), content: t('terms.section5Text') },
    { title: t('terms.section6Title'), content: t('terms.section6Text') },
  ];

  return (
    <div className="bg-background-dark text-white min-h-screen pt-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4">{t('terms.title')}</h1>
          <p className="text-white/50 mb-8">{t('terms.lastUpdated')}</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-white/70 text-lg mb-8">{t('terms.intro')}</p>
            
            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  className="bg-surface-dark border border-white/10 rounded-xl p-6"
                >
                  <h2 className="text-xl font-bold text-white mb-3">{section.title}</h2>
                  <p className="text-white/60 leading-relaxed">{section.content}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
